<script lang="ts">
    import cn from "classnames";

    let className = "";
    export { className as class };
</script>

<ul class={cn("gw-tabs", className)}>
    <slot />
</ul>

<style lang="postcss" global>
    .gw-tabs {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;
        list-style: none;
        overflow: auto;
        &::-webkit-scrollbar {
            display: none;
        }
    }

    @media all and (max-width: 600px) {
        .gw-tabs {
            justify-content: flex-start;
        }
    }
</style>
